module.exports = {
      id: "chevron-down-icon-usage",
      viewBox: "0 0 20 13",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#chevron-down-icon",
      toString: function () {
        return this.url;
      }
    }